<template>
    <div>
        <keyboard-events v-on:keyup="keyboardEvent"></keyboard-events>
        <div class="row">
            <!-- Columna Filtros -->
            <div class="col-md-3 mb-4">
                <div class="card shadow-sm border-0 rounded-lg p-3 bg-white card-custom-layout filters-card">
                    <h5 class="d-flex align-items-center mb-4 font-weight-bold text-dark-title">
                        <span class="mr-2 icon-bg text-primary-gradient"><i class="fas fa-sliders-h"></i></span>
                        Filtros de Búsqueda
                    </h5>
                    <div class="mb-4 select-container">
                        <filters-general ref="filtersReport"></filters-general>
                    </div>
                    <button class="btn btn-primary-gradient w-100 rounded-pill py-2 shadow-sm font-weight-bold transition-all d-flex align-items-center justify-content-center" @click="getReport">
                        <i class="fas fa-search mr-2"></i> Generar Reporte
                    </button>
                </div>
            </div>

            <!-- Columna Reporte e Información -->
            <div class="col-md-9 mb-4">
                <div class="card shadow-sm border-0 rounded-lg p-4 bg-white card-custom-layout main-report-card">
                    
                    <!-- Overlay de carga -->
                    <div class="loading-overlay" v-if="loadingGetData">
                        <div class="spinner-container">
                            <div class="modern-spinner mb-3"></div>
                            <h6 class="font-weight-bold text-dark mb-1">Consultando información de rutas</h6>
                            <p class="text-muted small m-0">Por favor, espere un momento...</p>
                        </div>
                    </div>

                    <vue-tabs active-tab-color="#4f46e5" active-text-color="white" class="custom-tabs-container">
                        <!-- Pestaña de Resumen Visual -->
                        <v-tab title="Reporte Visual" icon="fab fa-codiepie">
                            <div class="tab-content-container pt-3">
                                
                                <div v-if="!showData && !loadingGetData" class="empty-report-state">
                                    <div class="empty-icon-container mb-3">
                                        <i class="fas fa-chart-pie"></i>
                                    </div>
                                    <h6 class="font-weight-bold text-dark">Sin Datos de Reporte</h6>
                                    <p class="text-muted-light small px-5">Configure los filtros en el panel lateral y haga clic en <b>Generar Reporte</b> para visualizar el análisis de rutas.</p>
                                </div>

                                <div v-show="showData">
                                    <!-- Tarjetas KPI de Resumen -->
                                    <div class="row mb-4">
                                        <div class="col-md-4 mb-3">
                                            <div class="kpi-card bg-total h-100">
                                                <div class="kpi-icon text-primary"><i class="fas fa-route"></i></div>
                                                <div class="kpi-content">
                                                    <span class="kpi-label">Total Rutas</span>
                                                    <h3 class="kpi-value">{{ total || 0 }}</h3>
                                                    <span class="kpi-sub">100% Asignadas</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-4 mb-3">
                                            <div class="kpi-card bg-visitadas h-100">
                                                <div class="kpi-icon text-success"><i class="fas fa-check-circle"></i></div>
                                                <div class="kpi-content">
                                                    <span class="kpi-label">Visitadas</span>
                                                    <h3 class="kpi-value text-success">{{ visitadas || 0 }}</h3>
                                                    <span class="kpi-sub text-success-dark font-weight-bold">{{ getPercentage(visitadas) }}% del total</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-4 mb-3">
                                            <div class="kpi-card bg-proceso h-100">
                                                <div class="kpi-icon text-warning"><i class="fas fa-sync-alt fa-spin-hover"></i></div>
                                                <div class="kpi-content">
                                                    <span class="kpi-label">En Proceso</span>
                                                    <h3 class="kpi-value text-warning">{{ proceso || 0 }}</h3>
                                                    <span class="kpi-sub text-warning-dark font-weight-bold">{{ getPercentage(proceso) }}% en ruta</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <!-- Tabla de Desglose -->
                                        <div class="col-md-5">
                                            <div class="card shadow-sm border border-light rounded-lg p-3 bg-white h-100">
                                                <h6 class="font-weight-bold text-dark mb-3"><i class="fas fa-list-ol text-muted mr-1"></i> Detalle de Avance</h6>
                                                <div class="table-responsive">
                                                    <table class="table custom-summary-table m-0">
                                                        <thead>
                                                            <tr>
                                                                <th>Estado</th>
                                                                <th class="text-right">Cantidad</th>
                                                                <th class="text-right">Porcentaje</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr>
                                                                <td><span class="dot bg-success-dot"></span> Visitadas</td>
                                                                <td class="text-right font-weight-bold">{{ visitadas }}</td>
                                                                <td class="text-right text-success font-weight-bold">{{ getPercentage(visitadas) }}%</td>
                                                            </tr>
                                                            <tr>
                                                                <td><span class="dot bg-warning-dot"></span> En Proceso</td>
                                                                <td class="text-right font-weight-bold">{{ proceso }}</td>
                                                                <td class="text-right text-warning font-weight-bold">{{ getPercentage(proceso) }}%</td>
                                                            </tr>
                                                            <tr>
                                                                <td><span class="dot bg-info-dot"></span> No Visitadas</td>
                                                                <td class="text-right font-weight-bold">{{ novisitadas }}</td>
                                                                <td class="text-right text-info font-weight-bold">{{ getPercentage(novisitadas) }}%</td>
                                                            </tr>
                                                            <tr>
                                                                <td><span class="dot bg-secondary-dot"></span> Pendientes</td>
                                                                <td class="text-right font-weight-bold">{{ pendientes }}</td>
                                                                <td class="text-right text-muted font-weight-bold">{{ getPercentage(pendientes) }}%</td>
                                                            </tr>
                                                            <tr>
                                                                <td><span class="dot bg-danger-dot"></span> Canceladas</td>
                                                                <td class="text-right font-weight-bold">{{ canceladas }}</td>
                                                                <td class="text-right text-danger font-weight-bold">-</td>
                                                            </tr>
                                                            <tr class="table-total-row">
                                                                <td class="font-weight-bold">Total Asignado</td>
                                                                <td class="text-right font-weight-bold">{{ total }}</td>
                                                                <td class="text-right font-weight-bold">100%</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- Gráfica -->
                                        <div class="col-md-7">
                                            <div class="card shadow-sm border border-light rounded-lg p-3 bg-white h-100">
                                                <h6 class="font-weight-bold text-dark mb-2"><i class="fas fa-chart-pie text-muted mr-1"></i> Distribución de Avance</h6>
                                                <div class="chart-container">
                                                    <highcharts :options="chartOptions"></highcharts>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </v-tab>

                        <!-- Pestaña de Datos Tabular -->
                        <v-tab title="Tabla de Datos" icon="fas fa-table">
                            <div class="tab-content-container pt-3">
                                
                                <div v-if="!showData && !loadingGetData" class="empty-report-state">
                                    <div class="empty-icon-container mb-3">
                                        <i class="fas fa-table"></i>
                                    </div>
                                    <h6 class="font-weight-bold text-dark">Sin Registros cargados</h6>
                                    <p class="text-muted-light small">Configure los filtros en el panel lateral y haga clic en <b>Generar Reporte</b>.</p>
                                </div>

                                <div v-show="showData">
                                    <div class="d-flex justify-content-end mb-3">
                                        <button class="btn btn-excel-gradient rounded-pill px-4 shadow-sm border-0 d-flex align-items-center" @click="getReportExcel">
                                            <i class="fas fa-file-excel mr-2"></i> Generar Excel
                                        </button>
                                    </div>
                                    <div class="table-responsive custom-table-wrapper">
                                        <v-client-table :data="tableData" :columns="columns" :options="options">
                                            <div slot="Stt" slot-scope="props">
                                                <span class="status-badge" :class="getStatusClass(props.row.Stt)">
                                                    {{ props.row.Stt }}
                                                </span>
                                            </div>
                                            <div slot="Tiempo" slot-scope="props">
                                                <span class="time-badge">
                                                    <i class="far fa-clock mr-1"></i> {{ props.row.Tiempo }}
                                                </span>
                                            </div>
                                        </v-client-table>
                                    </div>
                                </div>

                            </div>
                        </v-tab>
                    </vue-tabs>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "report",
    data(){
        return{
            loadingGetData: false,
            showData: false,
            total: 0,
            visitadas: 0,
            novisitadas: 0,
            proceso: 0,
            pendientes: 0,
            canceladas: 0,
            chartOptions: {
                chart: {
                    plotBackgroundColor: null,
                    plotBorderWidth: null,
                    plotShadow: false,
                    type: 'pie',
                    backgroundColor: 'transparent',
                    height: 280
                },
                title: {
                    text: '',
                },
                tooltip: {
                    pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>',
                },
                plotOptions: {
                    pie: {
                        allowPointSelect: true,
                        cursor: 'pointer',
                        dataLabels: {
                            enabled: true,
                            style: {
                                textOverflow: 'clip',
                                fontSize: '11px',
                                textShadow: false,
                                textOutline: 'none',
                                fontWeight: '600'
                            },
                            format: '<span style="color:#475569">{point.name}: {point.percentage:.1f} %</span>',
                        }
                    }
                },
                credits: {
                    text: 'GRUPO PROMOCIONES - MOËT MÉXICO',
                    href: 'http://www.grupopromociones.com'
                },
                series: [{
                    name: 'Porcentaje',
                    colorByPoint: true,
                    data: [
                        { name: 'Visitadas', y: 0, color: '#10b981' },
                        { name: 'En Proceso', y: 0, color: '#f59e0b' },
                        { name: 'No Visitadas', y: 0, color: '#3b82f6' },
                        { name: 'Pendientes', y: 0, color: '#64748b' },
                        { name: 'Canceladas', y: 0, color: '#ef4444' }
                    ]
                }]
            },
            columns: ['Cveentrut', 'Fecha','Entrada','Salida','Rol','Gestor','Agencia','Area','Estado','Ciudad','Canal','Cadena','Formato','Tienda','Kcmid','Stt','Tiempo','Cmt'],
            tableData: [],
            options: {
                footerHeadings:false,
                filterByColumn:true,
                perPage:5,
                perPageValues: [5,10,15,25,45,50],
                filterable: ['Gestor','Stt','Kcmid'],
                sortable: ['Gestor','Ciudad','Rol'],
                listColumns: {
                    Agencia: [], 
                    Stt: [
                        {id:'Visitada',text:'Visitada'},
                        {id:'Pendiente',text:'Pendiente'},
                        {id:'Cancelada',text:'Cancelada'},
                        {id:'En Proceso',text:'En Proceso'}
                    ], 
                    Rol: [],
                },
                sortIcon: { 
                    base:'fontawesome', 
                    up:'fas fa-long-arrow-alt-up', 
                    down:'fas fa-long-arrow-alt-down', 
                    is:'fas fa-sort' 
                },
                headings: {
                    Cveentrut: '#',
                    Fecha: 'Fecha Ruta',
                    Stt: 'Estatus',
                    Cmt: 'Comentarios Entrada',
                    Kcmid: 'Id Tienda',
                },
                columnsClasses: {
                    Cveentrut: 'text-center align-middle',
                    Fecha: 'align-middle',
                    Rol: 'align-middle',
                    Gestor: 'align-middle font-weight-semibold',
                    Tienda: 'align-middle',
                    Kcmid: 'text-center align-middle',
                    Stt: 'text-center align-middle',
                    Tiempo: 'text-center align-middle',
                    Cmt: 'align-middle',
                },
                texts: {
                    count: "Mostrando {from} al {to} de {count} registros",
                    first: 'Primero',
                    last: 'Último',
                    filter: "Filtrar por columna:",
                    filterPlaceholder: "Buscar...",
                    limit: "Registros:",
                    page: "Página:",
                    noResults: "No hay resultados",
                    filterBy: "Filtrar por {column}",
                    loading: 'Recopilando información, por favor espere...',
                    defaultOption: 'Todos',
                    columns: 'Columnas'
                },
            }
        }
    },
    mounted() {
        this.$refs.filtersReport.shows.departamentos = false;
        this.$refs.filtersReport.shows.categorias = false;
        this.$refs.filtersReport.shows.fabricantes = false;
        this.$refs.filtersReport.shows.marcas = false;
        this.$refs.filtersReport.shows.productos = false;
        this.$refs.filtersReport.shows.trades = false;
    },
    methods:{
        keyboardEvent (e) {
            if (e.which === 13) {
                this.getReport();
            }
        },
        getPercentage(value) {
            if (!this.total || this.total === 0) return 0;
            return ((value * 100) / this.total).toFixed(1);
        },
        getStatusClass(status) {
            if (!status) return 'badge-secondary';
            const s = status.toLowerCase();
            if (s.includes('visitada')) return 'badge-success';
            if (s.includes('proceso')) return 'badge-warning';
            if (s.includes('cancelada')) return 'badge-danger';
            if (s.includes('pendiente')) return 'badge-secondary';
            return 'badge-info';
        },
        getReport(){ 
            let $this = this;
            var filters = this.$refs.filtersReport.filters;
            if (filters.timeInit === null){
                this.$toastMessage('error',"Fecha Inicio Es Obligatoria",4000,'center');
            }else if (filters.timeEnd === null){
                this.$toastMessage('error',"Fecha Termino Es Obligatoria",4000,'center');
            }else{
                this.loadingGetData = true;
                this.showData = false;
                axios.post('/api/ReporteRutas/getData',{data:filters})
                    .then(r => {
                            $this.loadingGetData = false;
                            $this.showData = true;
                            $this.total = r.data.Total;
                            $this.visitadas = r.data.Visitadas;
                            $this.proceso = r.data.En_proceso;
                            $this.novisitadas = r.data.No_visitada;
                            $this.pendientes = r.data.Pendientes;
                            $this.canceladas = r.data.Cancelada;
                            $this.tableData = r.data.Data;

                            const y0 = $this.total === 0 ? 0 : parseFloat((($this.visitadas*100)/$this.total).toFixed(2));
                            const y1 = $this.total === 0 ? 0 : parseFloat((($this.proceso*100)/$this.total).toFixed(2));
                            const y2 = $this.total === 0 ? 0 : parseFloat((($this.novisitadas*100)/$this.total).toFixed(2));
                            const y3 = $this.total === 0 ? 0 : parseFloat((($this.pendientes*100)/$this.total).toFixed(2));
                            const y4 = $this.total === 0 ? 0 : parseFloat((($this.canceladas*100)/$this.total).toFixed(2));

                            $this.chartOptions.series[0].data = [
                                { name: 'Visitadas', y: y0, color: '#10b981' },
                                { name: 'En Proceso', y: y1, color: '#f59e0b' },
                                { name: 'No Visitadas', y: y2, color: '#3b82f6' },
                                { name: 'Pendientes', y: y3, color: '#64748b' },
                                { name: 'Canceladas', y: y4, color: '#ef4444' }
                            ];
                        })
                    .catch(error => {
                        $this.loadingGetData = false;
                        $this.$toastMessage('error','Error: ' + error +' Por favor envia este error al área de soporte!',9000,'center');
                    });
            }
        },
        getReportExcel(){
            let $this = this;
            var filters = this.$refs.filtersReport.filters;
            if (filters.timeInit === null){
                this.$toastMessage('error',"Fecha Inicio Es Obligatoria",4000,'center');
            }
            else if (filters.timeEnd === null){
                this.$toastMessage('error',"Fecha Termino Es Obligatoria",4000,'center');
            }
            else{
                this.showData = false;
                axios({
                    method: 'post',
                    url: '/api/ReporteRutas/getDataExcel',
                    responseType: 'arraybuffer',
                    data: {data: filters}
                }).then(r => {
                        let blob = new Blob([r.data], { type: 'application/xlsx' })
                        let link = document.createElement('a')
                        link.href = window.URL.createObjectURL(blob)
                        link.download = 'ReporteRutasMoet.xlsx'
                        link.click()
                        $this.showData = true;
                    })
                .catch(error => {
                    $this.showData = true;
                    $this.$toastMessage('error','Error: ' + error +' Por favor envia este error al área de soporte!',9000,'center');
                });
            }
        }
    }
}
</script>

<style scoped>
    /* Card layouts */
    .card-custom-layout {
        transition: all 0.3s ease;
        border-radius: 16px !important;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05) !important;
    }

    .text-dark-title {
        color: #1e293b;
        font-size: 16px;
        letter-spacing: -0.2px;
    }

    /* Icon design */
    .icon-bg {
        width: 32px;
        height: 32px;
        border-radius: 8px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
    }

    .text-primary-gradient {
        background: rgba(79, 70, 229, 0.1);
        color: #4f46e5;
    }

    /* Primary gradient buttons */
    .btn-primary-gradient {
        background: linear-gradient(135deg, #4f46e5, #6366f1);
        color: white;
        transition: all 0.2s ease;
        border: none;
    }

    .btn-primary-gradient:hover {
        background: linear-gradient(135deg, #4338ca, #4f46e5);
        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(79, 70, 229, 0.2) !important;
        color: white;
    }

    .btn-excel-gradient {
        background: linear-gradient(135deg, #10b981, #059669);
        color: white;
        transition: all 0.2s ease;
        font-weight: 700;
        font-size: 13px;
    }

    .btn-excel-gradient:hover {
        background: linear-gradient(135deg, #059669, #047857);
        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(16, 185, 129, 0.2) !important;
        color: white;
    }

    /* Custom CSS Spinner Loader */
    .loading-overlay {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(255, 255, 255, 0.85);
        z-index: 10;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 16px;
        backdrop-filter: blur(4px);
    }

    .spinner-container {
        text-align: center;
    }

    .modern-spinner {
        width: 48px;
        height: 48px;
        border: 4px solid #f3f3f3;
        border-top: 4px solid #4f46e5;
        border-radius: 50%;
        animation: spin 1s linear infinite;
        display: inline-block;
    }

    @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }

    /* KPI Widgets */
    .kpi-card {
        padding: 16px 20px;
        border-radius: 14px;
        display: flex;
        align-items: center;
        box-shadow: 0 1px 3px rgba(0,0,0,0.02);
        border: 1px solid #f1f5f9;
        transition: all 0.25s ease;
    }

    .kpi-card:hover {
        transform: translateY(-2px);
        box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.05);
    }

    .kpi-icon {
        width: 46px;
        height: 46px;
        border-radius: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 20px;
        margin-right: 16px;
        flex-shrink: 0;
    }

    .kpi-content {
        display: flex;
        flex-direction: column;
    }

    .kpi-label {
        font-size: 11px;
        text-transform: uppercase;
        font-weight: 700;
        color: #94a3b8;
        letter-spacing: 0.5px;
    }

    .kpi-value {
        font-size: 24px;
        font-weight: 800;
        margin: 2px 0;
        line-height: 1;
        color: #1e293b;
    }

    .kpi-sub {
        font-size: 11px;
        font-weight: 500;
    }

    /* Color variations for KPI cards */
    .bg-total {
        background: #f8fafc;
    }
    .bg-total .kpi-icon {
        background: rgba(79, 70, 229, 0.1);
        color: #4f46e5;
    }
    .bg-visitadas {
        background: rgba(16, 185, 129, 0.02);
        border-color: rgba(16, 185, 129, 0.1);
    }
    .bg-visitadas .kpi-icon {
        background: rgba(16, 185, 129, 0.1);
        color: #10b981;
    }
    .text-success-dark {
        color: #047857;
    }
    .bg-proceso {
        background: rgba(245, 158, 11, 0.02);
        border-color: rgba(245, 158, 11, 0.1);
    }
    .bg-proceso .kpi-icon {
        background: rgba(245, 158, 11, 0.1);
        color: #f59e0b;
    }
    .text-warning-dark {
        color: #d97706;
    }

    .fa-spin-hover:hover {
        animation: fa-spin 2s infinite linear;
    }

    /* Summary breakdown table */
    .custom-summary-table {
        width: 100%;
    }
    .custom-summary-table th {
        font-size: 11px;
        text-transform: uppercase;
        color: #94a3b8;
        font-weight: 700;
        border: none !important;
        padding: 8px 12px !important;
    }
    .custom-summary-table td {
        padding: 10px 12px !important;
        font-size: 13px;
        border-top: 1px solid #f1f5f9 !important;
        border-bottom: none !important;
        vertical-align: middle;
        color: #334155;
    }
    .custom-summary-table tbody tr:first-child td {
        border-top: none !important;
    }
    .table-total-row td {
        border-top: 2px solid #cbd5e1 !important;
        font-weight: 700;
        color: #0f172a;
        font-size: 14px;
    }

    .dot {
        width: 8px;
        height: 8px;
        border-radius: 50%;
        display: inline-block;
        margin-right: 6px;
    }
    .bg-success-dot { background-color: #10b981; }
    .bg-warning-dot { background-color: #f59e0b; }
    .bg-info-dot { background-color: #3b82f6; }
    .bg-secondary-dot { background-color: #64748b; }
    .bg-danger-dot { background-color: #ef4444; }

    /* Empty states */
    .empty-report-state {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 60px 20px;
        text-align: center;
        background: #fafafa;
        border: 2px dashed #f1f5f9;
        border-radius: 12px;
        min-height: 340px;
    }

    .empty-icon-container {
        width: 64px;
        height: 64px;
        border-radius: 50%;
        background: rgba(148, 163, 184, 0.1);
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 26px;
        color: #64748b;
    }

    .text-muted-light {
        color: #94a3b8 !important;
    }

    /* Deep styling overrides for vue-tabs */
    .custom-tabs-container ::v-deep .nav-tabs {
        border-bottom: 2px solid #f1f5f9 !important;
        margin-bottom: 15px !important;
    }

    .custom-tabs-container ::v-deep .nav-tabs > li {
        margin-bottom: -2px !important;
    }

    .custom-tabs-container ::v-deep .nav-tabs > li > a {
        border: none !important;
        border-bottom: 2px solid transparent !important;
        color: #94a3b8 !important;
        font-weight: 700 !important;
        padding: 12px 20px !important;
        background: transparent !important;
        transition: all 0.2s ease !important;
        font-size: 13px !important;
        text-transform: uppercase;
        letter-spacing: 0.5px;
    }

    .custom-tabs-container ::v-deep .nav-tabs > li > a:hover {
        color: #4f46e5 !important;
    }

    .custom-tabs-container ::v-deep .nav-tabs > li.active > a {
        border-bottom: 2px solid #4f46e5 !important;
        color: #4f46e5 !important;
        font-weight: 700 !important;
    }

    /* Client table overrides */
    .custom-table-wrapper ::v-deep .VueTables__search-field {
        margin-bottom: 15px;
    }

    .custom-table-wrapper ::v-deep .VueTables__search-field input {
        border-radius: 50px !important;
        padding: 6px 16px !important;
        border: 1px solid #e2e8f0 !important;
        font-size: 13px !important;
        outline: none !important;
    }

    .custom-table-wrapper ::v-deep .VueTables__search-field input:focus {
        border-color: #4f46e5 !important;
        box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.1) !important;
    }

    .custom-table-wrapper ::v-deep table {
        border-collapse: separate !important;
        border-spacing: 0 6px !important;
        width: 100% !important;
    }

    .custom-table-wrapper ::v-deep table tbody tr {
        background-color: #f8fafc !important;
        transition: all 0.2s ease;
    }

    .custom-table-wrapper ::v-deep table tbody tr:hover {
        background-color: #f1f5f9 !important;
        transform: translateY(-1px);
    }

    .custom-table-wrapper ::v-deep table td {
        border: none !important;
        padding: 10px 14px !important;
    }

    .custom-table-wrapper ::v-deep table th {
        border: none !important;
        font-size: 11px !important;
        font-weight: 700 !important;
        color: #94a3b8 !important;
        text-transform: uppercase !important;
        padding: 8px 14px !important;
    }

    .custom-table-wrapper ::v-deep table tbody tr td:first-child {
        border-top-left-radius: 10px !important;
        border-bottom-left-radius: 10px !important;
    }

    .custom-table-wrapper ::v-deep table tbody tr td:last-child {
        border-top-right-radius: 10px !important;
        border-bottom-right-radius: 10px !important;
    }

    /* Badges styles */
    .status-badge {
        padding: 4px 10px;
        border-radius: 50px;
        font-size: 10px;
        font-weight: 700;
        text-transform: uppercase;
        display: inline-block;
    }

    .badge-success {
        background-color: rgba(16, 185, 129, 0.12);
        color: #10b981;
    }

    .badge-warning {
        background-color: rgba(245, 158, 11, 0.12);
        color: #f59e0b;
    }

    .badge-danger {
        background-color: rgba(239, 68, 68, 0.12);
        color: #ef4444;
    }

    .badge-secondary {
        background-color: rgba(148, 163, 184, 0.12);
        color: #64748b;
    }

    .badge-info {
        background-color: rgba(59, 130, 246, 0.12);
        color: #3b82f6;
    }

    .time-badge {
        color: #64748b;
        font-size: 12px;
        font-weight: 600;
    }

    .custom-table-wrapper ::v-deep .VuePagination {
        margin-top: 15px !important;
        display: flex !important;
        justify-content: center !important;
    }

    .custom-table-wrapper ::v-deep .pagination {
        display: flex !important;
        padding-left: 0 !important;
        list-style: none !important;
        border-radius: 50px !important;
    }

    .custom-table-wrapper ::v-deep .page-item.active .page-link {
        background-color: #4f46e5 !important;
        border-color: #4f46e5 !important;
        color: #ffffff !important;
    }

    .custom-table-wrapper ::v-deep .page-link {
        padding: 6px 12px !important;
        font-size: 12px !important;
        color: #4f46e5 !important;
        border: 1px solid #e2e8f0 !important;
    }
</style>
